import React from "react";
import "./WhatsAppFloat.css";

export default function WhatsAppFloat({ phoneNumber, defaultMessage }) {
  const message = encodeURIComponent(defaultMessage || "سلام! می‌خواهم درباره محصولات شما بپرسم");
  const link = `https://wa.me/${phoneNumber}?text=${message}`;

  return (
    <a
      href={link}
      target="_blank"
      rel="noopener noreferrer"
      className="whatsapp-float"
      title="پیام دادن در واتساپ"
    >
      <img src="/images/icons/whatsapp-icon.png" alt="WhatsApp" />
    </a>
  );
}
